import React from 'react'

export default function Header() {
    return (
        <header className="header">
            <div className="header--row">
                <nav className="navbar-container">
                    <div className="navbar-left">
                        <small className="navbar-left-powered-by">Powered by:</small>
                        <a href="https://www.designbuffs.com">
                            <img width="150px" src="https://designbuffs.com/wp-content/uploads/2019/10/designbuffs.png" />
                        </a>
                    </div>
                    <div className="navbar-center">
                        <a href="https://www.producthunt.com/posts/zoom-background-generator?utm_source=badge-featured&amp;utm_medium=badge&amp;utm_souce=badge-zoom-background-generator" >
                            <img src="https://api.producthunt.com/widgets/embed-image/v1/featured.svg?post_id=274641&amp;theme=dark" 
                                alt="Zoom Background Generator - Get a professional branded Zoom background in two clicks | Product Hunt" />       
                        </a>
                    </div>
                </nav>
            </div>
            <h1 className="header--headline">Free Zoom Background Generator</h1>
            <p className="header--byline highlighted">Generate a branded virtual background for your remote teams' video calls in seconds for free</p>
        </header>
    )
}